// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import http from './http/http'
// import store from './Common/global'
import UserInfo from './Common/UserInfo'
import '@/assets/iconfont/iconfont.css'
import DataV from '@jiaminghi/data-view'
import globalComponents from '@/Common/globalComponents'
import EasyPlayerLoader from '@/Common/EasyPlayerLoader'

Vue.use(ElementUI);
Vue.use(globalComponents);
Vue.use(DataV);
Vue.use(EasyPlayerLoader);

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  // store,
  components: { App },
  template: '<App/>',
  render :h=>h(App)
})

Vue.prototype.http = http;
Vue.prototype.http.init(vue);

Vue.prototype.UserInfo = UserInfo;
Vue.prototype.UserInfo.init(vue);


// WEBPACK FOOTER //
// ./src/main.js